import { makeSvgIcon } from '../makeSvgIcon'

export const plus = makeSvgIcon(
  <>
    <rect x="8" y="2" width="8" height="20" rx="2" />
    <rect x="2" y="8" width="20" height="8" rx="2" />
  </>
)
